import Clip from '@/api/clip'
// import { Promise } from "es6-promise";

/**
 * initial state
 */
const state = {
    fb_app_id: process.env.FACEBOOK_APP_ID,
    clips: [],
    articleList: [],
    userClipCategory: null,
    userClipCategoryError: null
}

/**
 * getters
 */
const getters = {
    fb_app_id: state => state.fb_app_id,
    clips: state => state.clips,
    articleList: state => state.articleList,
    userClipCategory: state => state.userClipCategory,
    userClipCategoryError: state => state.userClipCategoryError
}

/**
 * actions
 */
const actions = {

    getClipList({ commit }, params) {
        Clip.getClipList(params)
            .then(data => {
                commit('CLIPS_GET_SUCCESS', data)
            })
            .catch(error => {
                commit('CLIPS_GET_ERROR', error)
            })
    },

    getArticlesDetails({ commit }, params) {
        commit('SET_ARTICLE_LIST', params)
    },

    removeArticleFromStore({ commit }, params) {
        commit('UPDATE_ARTICLE_LIST', params)
    },

    getAllClipCategory({ commit }, params) {
        Clip.getAllClipCategory(params)
            .then(data => {
                commit('GET_ALL_CLIP_CATEGORY', data)
            })
            .catch(error => {
                commit('GET_ALL_CLIP_CATEGORY_ERROR', error)
            })

    },
}

/**
 * mutations
 */
const mutations = {

    SET_ARTICLE_LIST(state, data) {
        // console.log(data)
        state.articleList = data
        // data.forEach(article => {
        //   state.articleList = article.title
        // });
    },
    CLIPS_GET_SUCCESS(state, data) {
        state.clips = data.articles
    },

    UPDATE_ARTICLE_LIST(state, data) {
        let store_data = state.articleList
        store_data.forEach((post, index) => {
            if (post.article_id === parseInt(data)) {
                state.articleList.splice(index, 1)
            }
        })
    },

    GET_ALL_CLIP_CATEGORY(state, data) {
        state.userClipCategory = data
    },

    GET_ALL_CLIP_CATEGORY_ERROR(state, message) {
        state.userClipCategoryError = message
    }

}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/clip.js